import React, { Component } from 'react';
import Widget from './Widgets/Widget';
import { List, AutoSizer, WindowScroller } from 'react-virtualized';
import Helmet from 'react-helmet';
import './Listing.scss';
import { setParam, removeParameterFromUrl } from './../../../utils/helper';

let listRef;

class Listing extends Component {
  constructor(props) {
    super(props);
    this.lastScrollPos = 0;
    this.rowItems = 3;
    this.catScroll = this.catScroll.bind(this);
    this.mouseDownHandler = this.mouseDownHandler.bind(this);
    this.openYoutubeVideoPopUp = this.openYoutubeVideoPopUp.bind(this);
    this.prevIndex = 0;
    this.initialPageCounterInUrl = props.pageParam || 0;
    // this.leastIndex = !props.isCachedData && props.pageParam ? props.pageParam : 0;
    this.scrollProcessing = false;
  }

  componentDidMount() {
    if (Object.keys(this.props.FilterDataObj).length > 0) {
      setTimeout(() => {
        window.scrollTo(0, 1);
      }, 50);
    }
    window.addEventListener('scroll', this.catScroll, false);
  }

  componentDidUpdate(prevProps) {
    const { dittoEnable, categoryData, categoryScrollTo, categoryId, totalProductCount } =
      this.props;
    // used to update the grid on switchbar change.
    if (dittoEnable !== prevProps.dittoEnable && categoryData.num_of_products > 0 && listRef) {
      listRef.forceUpdateGrid();
    }
    // FORCE UPDATE WHEN CACHED DATA NEEDS TO SHOW
    if (prevProps.categoryId !== categoryId && listRef) {
      listRef.forceUpdateGrid();
    }
    if (prevProps.categoryData.category_name !== categoryData.category_name) {
      window.scrollTo(0, categoryScrollTo + 1);
    }
    if (prevProps.totalProductCount !== totalProductCount) {
      this.scrollProcessing = false;
      // fix: when user has scrolled to bottom of the page, and autosizer/windowscroller/virtualize is not catching up
      if (window.innerHeight + window.pageYOffset >= document.body.offsetHeight) {
        const sT = window.pageYOffset;
        window.scrollTo(0, sT - 2000);
      }
    }
  }

  componentWillUnmount() {
    const { categoryActions, FilterDataObj, location } = this.props;
    // save category data on unmount
    if (
      typeof window !== 'undefined' &&
      window.pageYOffset > 10 &&
      Object.getOwnPropertyNames(FilterDataObj).length === 0
    ) {
      const updateCatData = { location: location.pathname.slice(1), scrollTo: window.pageYOffset };
      categoryActions.debouceCategoryDataOnScroll(updateCatData);
    }
    window.removeEventListener('scroll', this.catScroll, false);
  }

  // to set dynamic height
  getDynamicRowHeight = data => {
    let categoryBanner;
    const { redisCommonData } = this.props;
    const bannerConfig =
      (redisCommonData?.BANNER_OFFER_CONFIG && JSON.parse(redisCommonData?.BANNER_OFFER_CONFIG)) ||
      {};
    if (typeof window !== 'undefined' && bannerConfig?.plp_banners) {
      categoryBanner = bannerConfig?.plp_banners?.find(item =>
        window?.location?.pathname.includes(item.category)
      );
    }
    const desktopBanner = categoryBanner?.desktop || [];
    const { index } = data;
    const bannerObj = desktopBanner?.find(item => item.index === index + 1);
    if (bannerObj && bannerObj?.banner_url?.length > 0 && bannerObj?.video_url?.length > 0) {
      if (redisCommonData && redisCommonData?.NEW_PLP_WIDGET === 'ON') {
        return 1000;
      }
      return 950;
    }
    if (bannerObj && bannerObj?.banner_url?.length > 0) {
      if (redisCommonData && redisCommonData?.NEW_PLP_WIDGET === 'ON') {
        return 700;
      }
      return 665;
    }
    if (bannerObj && bannerObj?.video_url_image?.length > 0) {
      if (redisCommonData && redisCommonData?.NEW_PLP_WIDGET === 'ON') {
        return 700;
      }
      return 665;
    }
    if (typeof window !== 'undefined' && window.screen.availWidth >= 1680) {
      if (redisCommonData && redisCommonData?.NEW_PLP_WIDGET === 'ON') {
        return 420;
      }
      return 365;
    } else if (typeof window !== 'undefined' && window.screen.availWidth < 1440) {
      if (redisCommonData?.NEW_PLP_WIDGET === 'ON') {
        return 390;
      }
      return 330;
    }
    if (redisCommonData && redisCommonData?.NEW_PLP_WIDGET === 'ON') {
      return 390;
    }
    return 330;
  };

  getHeight(height) {
    return typeof window !== 'undefined' ? height : 200;
  }

  getWidth(width) {
    return typeof window !== 'undefined' ? width : 1024;
  }

  mouseDownHandler(productData, position) {
    if (window.dtm.LenskartRewamp) {
      window.dtm.LenskartRewamp.Listing.click.ecommProductClicked(
        productData,
        position,
        this.props.login ? 'loggedIn' : 'guest',
        this.props.categoryId
      );
    }
    _gaq.push(
      ['_trackEvent', 'Category Page', 'Product Image Clicked', `page: ${document.location.href}`],
      [
        'ninja._trackEvent',
        'Category Page',
        'Product Image Clicked',
        `page: ${document.location.href}`,
      ]
    );
  }

  mouseHoverClick() {
    _gaq.push(
      ['_trackEvent', 'Color', 'categoryColor'],
      ['ninja._trackEvent', 'Color', 'categoryColor']
    );
  }

  handleScroll() {
    const pageInfo = `page: ${document.location.hostname}${document.location.pathname};Depth :0`;
    const { categoryData, location, counter, categoryActions, categoryId } = this.props;
    if (categoryData.num_of_products !== 0) {
      if (location.hash.length > 0) {
        let url = '';
        if (location.hash.includes('#')) {
          url = location.hash.split('#')[1];
        } else {
          url = location.hash;
        }
        const splittedUrl = url.split('&');
        let mystring = '';
        splittedUrl.forEach(value => {
          mystring =
            value?.indexOf('dir=') > -1 ||
            value?.indexOf('sort=') > -1 ||
            value?.indexOf('gan_data=') > -1
              ? `${mystring}&${value}`
              : `${mystring}&filter_${value}`;
          // mystring = `${mystring}&filter_${value}`;
        });
        categoryActions.loadScroll({
          pathname: window.location.pathname,
          categoryId,
          counter,
          mystring,
        }); // `${categoryId}?page-size=90&page=${counter}${mystring}`);
        _gaq.push(
          ['_trackEvent', 'Category Page', 'Scroll Depth', pageInfo],
          ['ninja._trackEvent', 'Category Page', 'Scroll Depth', pageInfo]
        );
      } else {
        categoryActions.loadScroll({
          pathname: window.location.pathname,
          categoryId,
          counter,
          mystring: '',
        });
        _gaq.push(
          ['_trackEvent', 'Category Page', 'Scroll Depth', pageInfo],
          ['ninja._trackEvent', 'Category Page', 'Scroll Depth', pageInfo]
        );
      }
    }
  }

  _rowRendered(data) {
    const { stopIndex } = data;
    const { redisCommonData } = this.props;
    const pageSize = redisCommonData.CATEGORY_PAGE_SIZE_COUNT
      ? redisCommonData.CATEGORY_PAGE_SIZE_COUNT
      : 15;
    const currIndex = Math.floor((stopIndex * this.rowItems) / pageSize);
    if (this.prevIndex !== currIndex) {
      this.prevIndex = currIndex;
      this.updatePageCounter();
    }
    this.props.listingScrollStop(stopIndex);
  }

  catScroll() {
    const sT = window.pageYOffset;
    const dBody = document.body;
    const dHtml = document.documentElement;
    const dHeight = Math.max(
      dBody.scrollHeight,
      dBody.offsetHeight,
      dHtml.clientHeight,
      dHtml.scrollHeight,
      dHtml.offsetHeight
    );
    if (
      !this.scrollProcessing &&
      window.innerHeight + sT >= dHeight - 2000 &&
      sT > this.lastScrollPos
    ) {
      this.scrollProcessing = true;
      this.lastScrollPos = sT;
      this.handleScroll();
    }
  }

  updatePageCounter() {
    const { currUrl, location, isCachedData } = this.props;
    if (isCachedData) {
      this.initialPageCounterInUrl = 0;
    }
    if (location.hash === '' && !location.pathname.includes('/search')) {
      const updatedIndex = this.initialPageCounterInUrl + this.prevIndex;
      // if (updatedIndex < this.leastIndex) { updatedIndex = this.leastIndex; }
      const updatedUrl = updatedIndex
        ? setParam(currUrl, 'page', updatedIndex)
        : removeParameterFromUrl(currUrl, 'page', this.prevIndex);
      window.history.replaceState(currUrl, null, updatedUrl);
    }
  }

  openYoutubeVideoPopUp(bannerObj) {
    this.props.openYoutubePopUp(bannerObj);
  }

  _renderRow(data) {
    let categoryBanner;
    const { index, key, style } = data;
    const updateStyle = { ...style };
    const {
      categoryData,
      dittoEnable,
      setWishList,
      location,
      history,
      toggleTryOn,
      //   dataLocale: { BOOK_HOME_TRIAL, BANNER },
      login,
      isExchange,
      redisCommonData,
    } = this.props;
    const rowItems = this.rowItems;
    // banner data
    const bannerConfig =
      (redisCommonData?.BANNER_OFFER_CONFIG && JSON.parse(redisCommonData?.BANNER_OFFER_CONFIG)) ||
      {};
    if (typeof window !== 'undefined') {
      categoryBanner = bannerConfig?.plp_banners.find(item =>
        window?.location?.pathname.includes(item.category)
      );
    }
    const desktopBanner = categoryBanner?.desktop || [];
    // Item Index's
    const indexFirstItem = index * rowItems;
    const dataIndexFirstItem = indexFirstItem + 0;
    const dataIndexSecondItem = indexFirstItem + 1;
    const dataIndexThirdItem = indexFirstItem + 2;
    // Item Object's
    const objectFirstRow = categoryData && categoryData.product_list[dataIndexFirstItem];
    const objectSecondRow = categoryData && categoryData.product_list[dataIndexSecondItem];
    const objectThirdRow = categoryData && categoryData.product_list[dataIndexThirdItem];
    const bannerMarginTop =
      redisCommonData && redisCommonData?.NEW_PLP_WIDGET === 'ON' ? '405px' : '365px';
    const performActions = (obj, indexNumber, isBanner, bannerObj, isVideoUrl) => {
      if (obj || isBanner || isVideoUrl) {
        return (
          <>
            {isVideoUrl ? (
              <div
                className="mt-8 image-conatiner"
                style={{
                  position: 'absolute',
                  marginTop: bannerObj?.banner_url?.length > 0 ? '700px' : bannerMarginTop,
                }}
              >
                <img alt="VIDEO-BANNER" src={bannerObj?.video_url_image} />
                <img
                  alt="youtube-icon"
                  className="youtube-icon"
                  src="/assets/svg/youtube-icon.svg"
                  onClick={() => this.openYoutubeVideoPopUp(bannerObj)}
                />
              </div>
            ) : isBanner ? (
              <div
                className="mt-8"
                style={{
                  position: 'absolute',
                  marginTop: bannerMarginTop,
                }}
              >
                <a href={bannerObj.banner_url_link}>
                  <img alt="BANNER" src={bannerObj.banner_url} />
                </a>
              </div>
            ) : (
              <div
                key={obj.id}
                className={`col-xs-12 col-sm-6 col-md-4 ${
                  index === 0 ? 'padding-diff' : 'padding-10'
                }`}
                unbxdattr="product"
                unbxdparam_prank={index + 1}
                unbxdparam_sku={obj.id}
                onFocus={this.mouseHoverClick}
                onMouseDown={() => this.mouseDownHandler(obj, indexNumber)}
                onMouseOver={this.mouseHoverClick}
              >
                <Widget
                  key={index}
                  colorOptions={obj.color_options}
                  dittoEnable={dittoEnable}
                  history={history}
                  isExchange={isExchange}
                  location={location}
                  login={login}
                  productData={obj}
                  setWishList={setWishList}
                  toggleTryOn={toggleTryOn}
                />
              </div>
            )}
          </>
        );
      }
    };
    const bannerObj = desktopBanner?.find(item => item.index === index + 1);
    return (
      <>
        <div key={key} style={updateStyle}>
          {[performActions(objectFirstRow, indexFirstItem, null)]}
          {[performActions(objectSecondRow, indexFirstItem + 1, null)]}
          {[performActions(objectThirdRow, indexFirstItem + 2, null)]}
          <div className="banner-video">
            {bannerObj && bannerObj?.banner_url?.length > 0 && (
              <div style={{ paddingTop: '20px !important', marginTop: '20px' }}>
                {bannerObj.index ? <>{[performActions(null, null, true, bannerObj)]}</> : null}
              </div>
            )}
            {bannerObj && bannerObj?.video_url?.length > 0 && (
              <div style={{ paddingTop: '10px !important', marginTop: '20px' }}>
                {bannerObj.index ? (
                  <>{[performActions(null, null, false, bannerObj, true)]}</>
                ) : null}
              </div>
            )}
          </div>
        </div>
      </>
    );
  }

  render() {
    const { categoryData, totalProductCount, location, filterFail, dataLocale } = this.props;
    // SEO default title for search page
    const searchPageTitle = dataLocale.SEO_DEFAULT_TITLE;
    // let rowHeight = 330;
    // if (typeof window !== 'undefined' && window.screen.availWidth >= 1680) {
    //   rowHeight = 365;
    // } else if (typeof window !== 'undefined' && window.screen.availWidth < 1440) {
    //   rowHeight = 310;
    // }
    const bannerCountTotal = 0;
    const rowCount = Math.ceil((totalProductCount + bannerCountTotal) / this.rowItems);
    const ssrHeight = 200;
    const ssrWidth = 200;
    return (
      <div key="listing" className={filterFail ? 'categoryListing full-width' : 'categoryListing'}>
        {location.pathname.includes('/search') && (
          <Helmet meta={[{ name: 'robots', content: 'noindex' }]} title={`${searchPageTitle}`} />
        )}
        {Boolean(categoryData && categoryData.product_list.length) && (
          <WindowScroller>
            {({ height, isScrolling, onChildScroll, scrollTop }) => (
              <AutoSizer disableHeight defaultHeight={ssrHeight} defaultWidth={ssrWidth}>
                {({ width }) => (
                  <List
                    ref={ref => {
                      listRef = ref;
                      return true;
                    }}
                    autoHeight
                    height={this.getHeight(height)}
                    isScrolling={isScrolling}
                    overscanRowCount={2}
                    rowCount={rowCount}
                    rowHeight={data => this.getDynamicRowHeight(data)}
                    rowRenderer={data => this._renderRow(data)}
                    scrollTop={scrollTop}
                    width={this.getWidth(width)}
                    onRowsRendered={data => this._rowRendered(data)}
                    onScroll={onChildScroll}
                  />
                )}
              </AutoSizer>
            )}
          </WindowScroller>
        )}
      </div>
    );
  }
}

export default Listing;
